import React from 'react';
import { Box, Flex, FlexProps } from '@withjoy/joykit';
import { TabbedPane } from '@shared/components';
import { StyledText, styles } from './AboutTabs.styles';
import { SkeletonText } from '@shared/components/Skeleton';
import { ReactComponent as IconDownChevron } from '@assets/icons/down-chevron.svg';

interface Tab {
  label: string;
  description: string;
}
interface AboutTabProps {
  tabsInfo: Tab[];
}

export const AboutTabs: React.FC<AboutTabProps> & { Skeleton: typeof AboutTabsSkeleton } = ({ tabsInfo }) => {
  return (
    <TabbedPane initialIndex={0} style={{ maxWidth: 800, margin: 'auto' }}>
      {tabsInfo.map((item, index) => {
        return <TabbedPane.Tab key={index} title={item.label}></TabbedPane.Tab>;
      })}
      <TabbedPane.Content>
        {tabsInfo.map((item, index) => {
          return (
            <Box key={index} style={{ maxWidth: '768px', margin: '0 auto', marginTop: '32px' }}>
              <StyledText textAlign="center" variant="body1" component="p">
                {item.description}
              </StyledText>
            </Box>
          );
        })}
      </TabbedPane.Content>
    </TabbedPane>
  );
};

const AboutTabsSkeleton = (props: FlexProps) => {
  return (
    <Box __css={styles.skeletonContainer} {...props}>
      <Box __css={styles.skeletonPaneContainer}>
        <Flex justifyContent="space-between">
          <SkeletonText rows={1} skeletonHeight={'42px'} width={200} />
          <Box as={IconDownChevron} __css={{ transform: `rotate(-180deg)` }} />
        </Flex>
        <Flex marginTop={10} flexDirection={['column', 'column', 'row']}>
          <Box flexGrow={0} flexBasis={[56, 56, 204]} marginRight={6}>
            <SkeletonText rows={1} width={130} skeletonHeight="28px" />
          </Box>
          <SkeletonText flexGrow={1} display="flex" flexDirection="column" rows={5} enableVaryingRowWidth={true} rowWidths={[82, 88, 90, 85, 75]} skeletonHeight={14} rowGap={3} />
        </Flex>
      </Box>
      <Box __css={styles.skeletonPaneContainer}>
        <Flex justifyContent="space-between">
          <SkeletonText rows={1} skeletonHeight={'42px'} width={320} />
          <Box as={IconDownChevron} />
        </Flex>
      </Box>
      <Box __css={styles.skeletonPaneContainer} />
    </Box>
  );
};

AboutTabs.Skeleton = AboutTabsSkeleton;
